import { render, staticRenderFns } from "./Translation.vue?vue&type=template&id=f93bb104&scoped=true"
import script from "./Translation.vue?vue&type=script&lang=js"
export * from "./Translation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93bb104",
  null
  
)

export default component.exports